'use client';

import { ToastProvider as RadixToastProvider } from '@radix-ui/react-toast';
import { ReactNode, useMemo, useState } from 'react';

import { Toast } from './Toast';
import { ToastDispatchContext } from './ToastContext';
import { ToastValues } from './ToastValues';
import { ToastViewport } from './ToastViewport';

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toastValues, setToastValues] = useState<ToastValues | undefined>(undefined);

  return (
    <ToastDispatchContext.Provider value={setToastValues}>
      {useMemo(
        () => (
          <>{children}</>
        ),
        [children],
      )}
      <RadixToastProvider>
        <ToastViewport />
        <Toast values={toastValues} />
      </RadixToastProvider>
    </ToastDispatchContext.Provider>
  );
};
